import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getAllUsersData = createApi(`GetAllUsers`,"GET");

const GetAllUsers = createSlice({
  name: 'GetAllUsers',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsersData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllUsersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllUsers.reducer;